function SuccessPage() {
    return (
      <div>
        <h1>Registro enviado com sucesso!</h1>
        <p>Obrigado por contribuir para a preservação dos corais 🌊.</p>
      </div>
    );
  }
  
  export default SuccessPage;
  